import { render } from "./TeamStatus.vue?vue&type=template&id=6b457ceb"
import script from "./TeamStatus.vue?vue&type=script&lang=js"
export * from "./TeamStatus.vue?vue&type=script&lang=js"

import "./TeamStatus.vue?vue&type=style&index=0&id=6b457ceb&lang=scss"
script.render = render

export default script